import { LandingReview } from "../../domain/entities/LandingReview"

interface ConstructorParams {
	id: number
	contentEs: string
	contentEn: string
	contentCa: string
	reviewerName: string
	reviewerTitleEs: string
	reviewerTitleEn: string
	reviewerTitleCa: string
	image?: string | null
	weight?: number
}

export class LandingReviewModel {
	public id: number
	public contentEs: string
	public contentEn: string
	public contentCa: string
	public reviewerName: string
	public reviewerTitleEs: string
	public reviewerTitleEn: string
	public reviewerTitleCa: string
	public image?: string | null
	public weight?: number

	constructor(params: ConstructorParams) {
		this.id = params.id
		this.contentEs = params.contentEs
		this.contentEn = params.contentEn
		this.contentCa = params.contentCa
		this.reviewerName = params.reviewerName
		this.reviewerTitleEs = params.reviewerTitleEs
		this.reviewerTitleEn = params.reviewerTitleEn
		this.reviewerTitleCa = params.reviewerTitleCa
		this.weight = params.weight
	}

	static fromRawJson = (rawJson: any): LandingReviewModel => {
		const mapped = {
			id: rawJson.id,
			reviewerName: rawJson.reviewer?.name || rawJson.reviewerName || "",
			reviewerTitleEs: rawJson.reviewer?.title || rawJson.reviewerTitleEs || "",
			reviewerTitleEn: rawJson.reviewer?.title || rawJson.reviewerTitleEn || "",
			reviewerTitleCa: rawJson.reviewer?.title || rawJson.reviewerTitleCa || "",
			contentEs: rawJson.content || rawJson.contentEs || "",
			contentEn: rawJson.content || rawJson.contentEn || "",
			contentCa: rawJson.content || rawJson.contentCa || "",
			image: rawJson.image || null,
			weight: rawJson.weight ?? 0
		}
		return new LandingReviewModel(mapped)
	}

	static fromDomain = (landingReview: LandingReview): LandingReviewModel => {
		return new LandingReviewModel(landingReview)
	}
}

declare module "./LandingReviewModel" {
	interface LandingReviewModel {
		toDomain(): LandingReview
	}
}

LandingReviewModel.prototype.toDomain = function (): LandingReview {
	const data = this
	return new LandingReview({
		...data
	})
}
